/**
 * SelectAdminGroup
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useApi2 } from 'containers/Api2/index.js';
import { GROUPTYPES_CLASS } from 'containers/User/constants.js';
import Spinner from 'components/Spinner/index.jsx';
import ReactSelect from 'components/interaction/ReactSelect/index.jsx';
import naturalSort from 'utils/naturalSort.js';
import messages from '../messages.js';

function adminGroups2options(group) {
  return group.list.map((id) => ({
    value: id,
    name: `${group[id].name}|${group[id].yearClass}`,
    label: (
      <div className="d-flex justify-content-between">
        <span>{group[id].name}</span>
        <div className="text-end">
          <FormattedMessage {...messages.gradeFull} values={group[id]} />
        </div>
      </div>
    ),
  }));
}
function SelectAdminGroup(props) {
  const { value, ...rest } = props;
  const intl = useIntl();
  const selector = `sa/groups/${GROUPTYPES_CLASS}`;
  const url = 'sa/administrativegroups';
  const groups = useApi2({ url, selector, version: 2 });
  if (groups.loading) {
    return <Spinner />;
  }
  const select = intl.formatMessage(messages.select);
  const none = intl.formatMessage(messages.none);
  const options = adminGroups2options(groups).sort((a, b) => naturalSort(a.name, b.name));
  options.unshift({ label: none });
  return (
    <ReactSelect
      value={value}
      {...rest}
      options={options}
      placeholder={select}
    />
  );
}

SelectAdminGroup.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default SelectAdminGroup;
